import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function Terms() {
  return (
    <>
    <Navigation/>
    <div className="container">
    <div className="entry-content wp-block-post-content has-global-padding is-layout-constrained wp-block-post-content-is-layout-constrained" bis_skin_checked="1">
    <p>Päivitetty viimeksi: 11. tammikuuta 2025</p>

    <p>Ole hyvä ja lue nämä käyttöehdot ("Ehdot", "Käyttöehdot") huolellisesti ennen kuin käytät verkkosivustoa https://finlandgesocial.com ("Palvelu"), jota ylläpitää https://finlandgesocial.com ("me", "meidän" tai "meitä").</p>

    <p>Palveluun pääsy ja sen käyttö edellyttävät näiden Ehtojen hyväksymistä ja noudattamista. Nämä Ehdot koskevat kaikkia vierailijoita, käyttäjiä ja muita, jotka käyttävät Palvelua.</p>

    <p>Käyttämällä Palvelua hyväksyt nämä Ehdot. Jos et hyväksy näitä ehtoja tai niiden osaa, et voi käyttää Palvelua.</p>

    <p>Ennen sovelluksen lataamista, ole hyvä ja lue käyttöehtomme. Lataamalla ja käyttämällä sovellustamme hyväksyt seuraavat:</p>

    <ul>
        <li>Olet lukenut ja ymmärtänyt käyttöehtomme kokonaisuudessaan.</li>
        <li>Sitoudut käyttämään Palveluamme lainmukaisesti.</li>
        <li>Hyväksyt henkilötietojesi käsittelyn tietosuojakäytäntömme mukaisesti.</li>
    </ul>

    <p>Olet tarkistanut ja hyväksynyt vastuullisen pelaamisen sääntömme.</p>

    <h2 className="wp-block-heading">Keskeiset määräykset</h2>

    <p>1.1. Nämä käyttöehdot määrittävät säännöt vuorovaikutteisten palveluiden ("Palvelut") käytölle, joita palveluntarjoaja tarjoaa verkkosivuston https://finlandgesocial.com ("Palvelu") kautta.</p>

    <p>1.2. Palveluntarjoajan tarjoamat palvelut sisältävät rekisteröityneiden käyttäjien ("Osallistujat") pääsyn pelialustalle, joka on tarkoitettu viihdetarkoituksiin. Käyttäjät voivat olla vuorovaikutuksessa, jakaa tietoa ja keskustella peleihin liittyvistä aiheista.</p>

    <p>1.3. Tarjottujen palveluiden puitteissa osallistujat voivat osallistua peleihin, joissa lopputulos riippuu heidän reaktionopeudestaan, ketteryydestään ja havainnointikyvystään. Voittaminen edellyttää eniten pisteitä keräämistä.</p>

    <p>1.4. Palveluiden käyttö ja jäsenyyden hakeminen Palvelussa merkitsee tässä asiakirjassa esitettyjen ehtojen tunnustamista ja hyväksymistä. Käyttäjät, jotka käyttävät Palvelua ilman rekisteröitymistä osallistujiksi, ovat silti velvollisia noudattamaan näitä käyttöehtoja.</p>

    <p>1.5. Palveluntarjoaja korostaa, että yksittäisiä sopimuksia ei tehdä Palvelun käyttäjien tai osallistujien kanssa. Kaikkien Palveluntarjoajan tarjoamia palveluita käyttävien on noudatettava näitä käyttöehtoja.</p>

    <p>1.6. Kaikkien pelien ominaisuuksien täysimääräinen käyttö riippuu käyttäjän tietokoneen tai mobiililaitteen teknisestä yhteensopivuudesta Palvelun kanssa.</p>

    <p>1.7. Palveluntarjoaja ei ole vastuussa Palvelun saatavuuden puutteesta tekijöiden vuoksi, jotka eivät ole sen hallinnassa, tai odottamattomien olosuhteiden vuoksi.</p>

    <h2 className="wp-block-heading">Vastuullisen pelaamisen säännöt</h2>

    <p>Verkkopalvelumme päätavoitteena on tarjota käyttäjille viihdettä ja laajentaa heidän tietämystään peleistä. Toivomme, että kaikki käyttäjät käyttävät palveluita näihin tarkoituksiin. Joillekin käyttäjille palveluiden käyttö voi kuitenkin muuttua liialliseksi ajankäytöksi. Näitä tapauksia voidaan välttää noudattamalla seuraavia perussääntöjä:</p>

    <ul>
        <li>Pelaa huvin vuoksi.</li>
        <li>Ymmärrä, että pisteillä ei ole todellista arvoa ja niitä tulee pitää henkilökohtaisen tyydytyksen lähteenä.</li>
        <li>Tavoittele voittoa, mutta vältä kostamista.</li>
        <li>Vältä pelaamista, kun tunnet olosi surulliseksi, väsyneeksi tai turhautuneeksi.</li>
    </ul>

    <h2 className="wp-block-heading">Ota yhteyttä</h2>

    <p>Jos sinulla on kysyttävää näistä ehdoista, ota meihin yhteyttä.</p>
</div>


    </div>
    <Footer/>
    </>
  )
}

export default Terms